export default {
  navDrawerTypes: [
    { label: 'Default', value: 'default' },
    { label: 'Pinned', value: 'pinned' },
    { label: 'Slide Over', value: 'hover' }
  ],
  general: {
    darkTheme: false
  },
  navDrawer: {
    opened: true,
    type: 'default',
    clipped: true,
    floating: false,
    mini: false
  }
}
